'use client';

import { c as _c } from "react/compiler-runtime";
import { animate } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
import { type BlackLayerProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/black-layer/types';
import { cn } from '@/app/utils/cn';
export const BlackLayer = t0 => {
  const $ = _c(13);
  const {
    isVisible,
    durationSeconds,
    className,
    style,
    children
  } = t0;
  const layerRef = useRef(null);
  let t1;
  if ($[0] !== isVisible) {
    t1 = () => isVisible ? 1 : 0;
    $[0] = isVisible;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [initialOpacity] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== durationSeconds || $[3] !== isVisible) {
    t2 = () => {
      const layer = layerRef.current;
      if (!layer) {
        return;
      }
      const controls = animate(layer, {
        opacity: isVisible ? 1 : 0
      }, {
        duration: durationSeconds,
        ease: "linear"
      });
      return () => controls.stop();
    };
    t3 = [isVisible, durationSeconds];
    $[2] = durationSeconds;
    $[3] = isVisible;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const t4 = !initialOpacity;
  let t5;
  if ($[6] !== className || $[7] !== t4) {
    t5 = cn("pointer-events-none absolute inset-0 bg-black", {
      "opacity-0": t4
    }, className);
    $[6] = className;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== style || $[11] !== t5) {
    t6 = <div aria-hidden={true} ref={layerRef} style={style} className={t5}>{children}</div>;
    $[9] = children;
    $[10] = style;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};